import React from 'react'
import { Modal } from 'react-bootstrap'
import { Button } from '@abroad/components'

const UnsavedDocumentModal = ({ showModal, handleClose, handleLeave }) => {
  const modalClose = () => {
    handleClose()
  }
  const modalLeave = () => {
    handleLeave()
  }

  return (
    <>
      <Modal
        show={showModal}
        onHide={handleClose}
        centered
        className='payment-modal'>
        <Modal.Header className='payment-modal-header d-flex justify-content-center'>
          <h3 className='payment-modal-title mb-0'>Delete File or Image</h3>
        </Modal.Header>
        <Modal.Body className='payment-modal-body'>
          <div className='s7'>
            Are you sure you want to delete this file or image? This action
            cannot be undone.
          </div>
        </Modal.Body>
        <Modal.Footer className='border-0 d-flex justify-content-end pt-0'>
          <Button
            variant='secondary-light'
            onClick={modalClose}
            className='px-3'
            size='sm'>
            Cancel
          </Button>
          <Button
            variant='saffron'
            onClick={modalLeave}
            className='px-3 ms-2 text-white'
            size='sm'>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default UnsavedDocumentModal
